// theirs
import styled from 'styled-components'
// ours
import { CallToActionProps } from '.'
import { breakpoints, color, typography } from '../../../styles'
import { appendLocationSingle } from '../../../utils/append-location'

export const callToActionBaseClass = 'call-to-action'

export const StyledCallToAction = styled.div<CallToActionProps>`
    &.${callToActionBaseClass} {
        background-color: ${color.darkest};
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;
        z-index: 2;

        display: grid;
        grid-template-rows: 2fr 1fr 1fr 1fr;
        grid-template-areas:
            'Top Top'
            'Left Left'
            'Middle Middle'
            'Right Right';

        @media (min-width: ${breakpoints.lg}) {
            grid-template-columns: 1fr 1fr 1fr;
            grid-template-rows: 2fr 1fr;
            grid-template-areas: 'Top Top Top' 'Left Middle Right';
        }

        @media (min-width: ${breakpoints.xl}) {
            grid-template-rows: 2fr 1fr;
        }

        .content-top {
            grid-area: Top;
            overflow: hidden;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: url(${(props) =>
                    appendLocationSingle(
                        'images',
                        props.content.contentBackgroundGrayscaleImageSource
                    )});
                filter: grayscale(100%);
                background-size: cover;
                background-position: center;
            }

            div {
                background: url(${(props) =>
                    appendLocationSingle(
                        'images',
                        props.content.contentBackgroundImageSource
                    )});
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center;
                height: 100%;
                position: relative;
            }
        }

        .content-left {
            grid-area: Left;
            background-color: ${(props) =>
                props.content.contentBackgroundColor};
            display: table;

            p {
                color: ${color.cultured};
            }

            a {
                color: ${color.cultured};
                border-color: ${color.cultured};
            }
        }

        .content-middle {
            grid-area: Middle;
            background-color: ${(props) =>
                props.content.contentSecondBackgroundColor};
            display: table;

            h2 {
                color: ${color.lightest};
            }
            p {
                color: ${color.lightest};
            }

            a {
                color: ${color.lightest};
                border-color: ${color.lightest};
            }
        }

        .content-right {
            grid-area: Right;
            background-color: ${(props) =>
                props.content.contentThirdBackgroundColor};
            display: table;

            p {
                color: ${color.raisinblack};
            }

            a {
                color: ${color.raisinblack};
                border-color: ${color.raisinblack};
            }
        }

        .content-outer {
            display: table-cell;
            vertical-align: middle;
            padding-top: 0;
        }

        .content-inner {
            max-width: 550px;
            margin: 0 auto;

            @media (min-width: ${breakpoints.lg}) {
                min-height: 170px;
            }
        }

        .title-wrapper {
            display: block;
            margin-bottom: 0;

            @media (min-width: ${breakpoints.xs}) {
                margin-bottom: 0.5rem;
            }

            @media (min-width: ${breakpoints.md}) {
                margin-bottom: 1rem;
            }
        }

        h2 {
            font-family: ${typography.type.secondary};
            font-weight: ${typography.weight.bold};
            font-style: ${typography.style.normal};
            font-size: ${typography.size.l2};
            color: ${color.deepcarminepink};
            text-transform: uppercase;
            text-align: center;
            margin: 0 auto 0 auto;
            padding: 0;

            letter-spacing: normal;
            line-height: normal;

            @media (min-width: ${breakpoints.lg}) {
                margin-bottom: 0;
            }
        }

        .text-wrapper {
            display: none;
            margin-bottom: 0.5rem;
            padding: 0 1rem;

            @media (min-width: ${breakpoints.sm}) {
                display: block;
                margin-bottom: 1rem;
            }

            @media (min-width: ${breakpoints.md}) {
                margin-bottom: 2.5rem;
            }

            @media (min-width: ${breakpoints.lg}) {
                min-height: 53px;
                margin-bottom: 1rem;
                padding-right: 3.5rem;
                padding-left: 3.5rem;
            }

            @media (min-width: ${breakpoints.xxl}) {
                min-height: auto;
                margin-bottom: 2.5rem;
                padding-right: 1rem;
                padding-left: 1rem;
            }

            p {
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.64;
                letter-spacing: 0.88px;
                text-align: center;
            }
        }

        .call-to-action-wrapper {
            text-align: center;

            a {
                font-family: ${typography.type.secondary};
                font-weight: ${typography.weight.bold};
                font-style: ${typography.style.normal};
                font-size: ${typography.size.m1};
                text-transform: uppercase;
                text-decoration: none;
                border-style: solid;
                border-width: 3px;
                border-radius: 30px;
                padding: 10px 32px 6px 32px;
                width: 230px;
                display: block;
                margin: 0 auto;
                line-height: 1;
            }
        }
    }
`
